import { render, staticRenderFns } from "./addSnakes.vue?vue&type=template&id=9571969e"
import script from "./addSnakes.vue?vue&type=script&lang=js"
export * from "./addSnakes.vue?vue&type=script&lang=js"
import style0 from "./addSnakes.vue?vue&type=style&index=0&id=9571969e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports